import { Status } from '@gogame/components';

export const getColor = (id) => {
  switch (id) {
    case -1:
      return 'inactive';
    case 0:
      return 'success';
    case 1:
      return 'pending';
    case 2:
      return 'pending';
    case 3:
      return 'error';
    case 4:
      return 'error';
    case 5:
      return 'info';
    case 6:
      return 'inactive';
  }
};
export default ({ id, children }) => (
  <Status color={getColor(id)}>{children}</Status>
);
